import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { EventService } from '../../event/event.service';
import { FacetChangedEvent } from './product.events';

@Injectable({
  providedIn: 'root',
})
export class ProductEventBuilder {
  constructor(protected eventService: EventService) {
    this.register();
  }

  protected register(): void {
    this.eventService.register(FacetChangedEvent, this.buildFacetChangedEvent());
  }

  /**
   * To get the changed facet, we need to compare the product search results
   * got before and after toggling the facet value. These 2 product searches must
   * have the same search queries except one different solr filter term. That means
   * these 2 searches must have the same 'freeTextSearch'; and if they are category
   * searches, they must have the same root (in the same category or brand).
   */
  protected buildFacetChangedEvent(): Observable<FacetChangedEvent> {
   return EMPTY;
  }

}
